export default __webpack_public_path__ + "static/media/Track alumni jobs.c7668d6f.png";